// extracted by mini-css-extract-plugin
module.exports = {"root":"Paragraph_root__1P-d6","dark":"Paragraph_dark__1_W6c"};